export const comments_3324445 = {"data":{"data":[],"links":{}}}